import React from "react";

import "../styles/quiz-form.scss";
import { new_, texts } from "../lib/constants";

function QuizFormInitial({ language, userStateForm }) {
  return (
    <div className="quiz-form-initial">
      <h4>
        {texts[language].selectQuestionsGroupTitleStart}{" "}
        {userStateForm === new_
          ? texts[language].start
          : texts[language].continue}{" "}
        {texts[language].selectQuestionsGroupTitleContinue}
      </h4>
      {userStateForm === new_ && (
        <div className="quiz-form-note">
          <p>{texts[language].questionsNote1}</p>
          <p>
            {texts[language].questionsNote2}
          </p>
          <p>{texts[language].questionsNote3}</p>
        </div>
      )}
    </div>
  );
}

export default QuizFormInitial;
